<template>
<div class="content">
  <div class="sidebar" :class="{'active': showSidebar}">
    <tabs>
      <tab name="Stocks" selected>
        <input class="stock-search"
          v-model="stockFilter"
          type="text"
          placeholder="Search..."
          @keyup.enter="goToFirstStock()">
        <div class="stock-list">
          <list-item v-for="stock in filteredStocks"
            :key="stock.symbol"
            :active="stock.symbol == $route.params.symbol"
            :title="stock.symbol"
            :subtitle="stock.name"
            :starred="stock.starred"
            @click.native="goToStock(stock.symbol)">
          </list-item>
          <list-item
            :title="'Go to ' + stockFilter.toUpperCase()"
            v-if="stockFilter !== ''"
            @click.native="goToStock(stockFilter)">
          </list-item>
        </div>
      </tab>
      <tab name="Notes">
        <div class="stock-list">
          <list-item v-for="note in notes"
            :key="note.name"
            :active="note.name == $route.params.name"
            :title="note.title"
            @click.native="goToNote(note.name)">
          </list-item>
        </div>
      </tab>
    </tabs>
  </div>
  <div class="belly">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';
import { mapState, mapMutations } from 'vuex';

export default {
  data(){ return{
    stockFilter: ''
  }},

  computed: {
    filteredStocks(){
      let starred = [];
      let notStarred = [];
      this.stocks.forEach((item, index, array) => {
        if(item.starred){
          starred.push(item);
        }else{
          notStarred.push(item);
        }
      });

      starred.sort((a, b) => {
        return a.symbol>b.symbol ? 1:(a.symbol<b.symbol) ? -1:0;
      });

      notStarred.sort((a, b) => {
        return a.symbol>b.symbol ? 1:(a.symbol<b.symbol) ? -1:0;
      });

      return starred.concat(notStarred).filter(item => {
        return item.symbol.toLowerCase().includes(this.stockFilter)
          || item.name.includes(this.stockFilter);
      });
    },

    ...mapState([
      'showSidebar'
    ])
  },

  firebase: {
    stocks: Firebase.stocks,
    notes: Firebase.notes
  },

  methods: {
    goToStock(symbol){
      this.$router.push('/stock/' + symbol.toUpperCase());
      this.hideSidebar();
    },

    goToNote(name){
      this.$router.push('/note/' + name);
      this.hideSidebar();
    },

    goToFirstStock(){
      let firstStock = this.stockFilter.toUpperCase();
      if(this.filteredStocks.length > 0){
        firstStock = this.filteredStocks[0].symbol;
      }
      this.goToStock(firstStock);
    },

    ...mapMutations([
      'hideSidebar'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?62b6526e